import { Col, Row } from 'react-bootstrap';
import type { SkillProposalRow } from '../../apps/apis/claudeCodeDashboard/types';
import SkillProposalCard from './SkillProposalCard';

interface Props {
  proposals: SkillProposalRow[];
}

const SkillProposalQueue = ({ proposals }: Props) => {
  if (proposals.length === 0) {
    return <div className="text-muted small">No skill proposals match the selected filters.</div>;
  }

  return (
    <Row className="g-3">
      {proposals.map((proposal) => (
        <Col lg={6} key={proposal.proposalId}>
          <SkillProposalCard proposal={proposal} />
        </Col>
      ))}
    </Row>
  );
};

export default SkillProposalQueue;
